import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error";
import FormRow from "src/core/gd-form/form/form-ui5/form-row";
import FormSelect from "core/gd-form/form-element/select-new/select-new";

export default function CustomFieldAccess(props) {

    const accessOptions = [
        { label: gd.const.customFields.accessLabel.MANAGERS_ONLY,   value: gd.const.customFields.access.MANAGERS_ONLY },
        { label: gd.const.customFields.accessLabel.EVERYONE,        value: gd.const.customFields.access.EVERYONE }
    ];

    return (
        <FormRow label="Display to">
            <FormSelect form={props.form} name="access" options={accessOptions} placeholder="Please select" />
            <FormError form={props.form} name="access"/>
        </FormRow>
    );
}

CustomFieldAccess.propTypes = {
    form: PropTypes.object
}
